import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Injectable()
export class HoverService {
    hoverItem$ = new BehaviorSubject(false);
    hoverSubitem$ = new BehaviorSubject(false);
    hoverNav$ = combineLatest([this.hoverItem$, this.hoverSubitem$]).pipe(
        debounceTime(5),
        map((hovers) => hovers.includes(true)),
    );
}
